import { memo } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Local files
import { StyledListItem } from './Item.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';

const Item = ({ id, title, text, updated_at }) => { 
  const { setSixthFlowPromptsDrawer } = useApp();
  const date = new Date(updated_at).toLocaleDateString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

  return (
    <StyledListItem disablePadding>
      <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Typography variant='subtitle2' noWrap>Title: {title}</Typography>
        <Typography variant='subtitle2' noWrap>{date}</Typography>
      </Box>
      <Button variant='contained' onClick={() => setSixthFlowPromptsDrawer({ open: true, edit: true, id, title, text })} sx={{ mr: 1 }}>View</Button>
    </StyledListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);